import api from "./api";

export const priceListsService = {
  list() {
    return api.get("/price-lists");
  },
  get(id) {
    return api.get(`/price-lists/${id}`);
  },
  create(payload) {
    return api.post("/price-lists", payload);
  },
  update(id, payload) {
    return api.patch(`/price-lists/${id}`, payload);
  },
  listItems(id) {
    return api.get(`/price-lists/${id}/items`);
  },
  createItem(id, payload) {
    return api.post(`/price-lists/${id}/items`, payload);
  },
  createAllMissingItems(id, payload = {}) {
    return api.post(`/price-lists/${id}/items/all`, payload);
  },
  updateItem(id, itemId, payload) {
    return api.patch(`/price-lists/${id}/items/${itemId}`, payload);
  },
  deleteItem(id, itemId) {
    return api.delete(`/price-lists/${id}/items/${itemId}`);
  },
  uploadItemsFile(id, formData, params) {
    return api.post(`/price-lists/${id}/items/upload`, formData, {
      params,
      // Una importación WooCommerce puede descargar miles de imágenes.
      timeout: 10 * 60 * 1000,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  listItemsExtended(id, params) {
    return api.get(`/price-lists/${id}/items/extended`, { params });
  },
  exportItems(id, params) {
    return api.get(`/price-lists/${id}/items/export`, { params, responseType: "blob" });
  },
  listUpdates(id) {
    return api.get(`/price-lists/${id}/updates`);
  },
  createUpdate(id, payload) {
    return api.post(`/price-lists/${id}/updates`, payload);
  },
  confirmUpdate(updateId) {
    return api.post(`/price-lists/updates/${updateId}/confirm`);
  },
  listHistory(id, params) {
    return api.get(`/price-lists/${id}/history`, { params });
  },
};
